export default __webpack_public_path__ + "static/media/19.b7e8e0b4.jpg";